module.exports = __webpack_public_path__ + "static/media/otp.1a4113c7.webp";